import * as React from 'react'
import {FormEvent, useEffect, useMemo, useState} from 'react'
import logo from '../static/img/logo.svg';
import "../styles/main.css";
import {allWords, cppWords, csWords, goWords, javaWords, jsWords, langWords, pyWords, sqlWords} from "./words";


const TypeTester = () => {
    const [words, setWords] = useState(allWords);
    const [reloadCounter, setReloadCounter] = useState(0);

    const [seconds, setSeconds] = useState(60);
    const [isOnTimer, setIsOnTimer] = useState(false);
    const [curIndex, setCurIndex] = useState(0);
    const [curInput, setCurInput] = useState("");
    const [result, setResult] = useState(0);

    const getGeneratedWords = () => {
        const result = [];
        // By this we generate most useful keywords
        const length = Math.min(100, words.length);
        for (let i = 0; i < 100; i++) {
            let generatedWord = words[Math.floor(Math.random() * (length + 1))];
            while (!generatedWord) {
                generatedWord = words[Math.floor(Math.random() * (words.length + 1))];
            }
            result.push(generatedWord);
        }
        return result;
    }
    const wordsList = useMemo(() => getGeneratedWords(), [words, reloadCounter]);

    const onLanguageClick = (newWords: string[]) => {
        setWords(newWords)
    }

    useEffect(() => {
        if (!isOnTimer || !seconds) {
            setIsOnTimer(false);
            return;
        }

        const intervalId = setInterval(() => setSeconds(seconds - 1), 1000);

        return () => clearInterval(intervalId);
    }, [isOnTimer, seconds])

    const onChange = (event: FormEvent<HTMLInputElement>) => {
        if (seconds != 60 && !isOnTimer) return;

        if (!isOnTimer) {
            document.getElementById(`p-${curIndex}`)!.style.backgroundColor = "#bebebe";
            setIsOnTimer(true);
        }

        setCurInput(event.currentTarget.value);
        const word = event.currentTarget.value;
        if (!wordsList[curIndex].includes(word)) {
            document.getElementById(`p-${curIndex}`)!.style.backgroundColor = "#ff5454";
        } else {
            document.getElementById(`p-${curIndex}`)!.style.backgroundColor = "#bebebe";
        }
        if (word[word.length - 1] == " ") {
            document.getElementById(`p-${curIndex}`)!.style.backgroundColor = "white";
            document.getElementById(`p-${curIndex}`)!.style.color = "#910000";
            if (wordsList[curIndex] == curInput.trim()) {
                setResult(result + 1);
                document.getElementById(`p-${curIndex}`)!.style.color = "#1d8c00";
            }
            setCurInput("");
            if (curIndex == wordsList.length - 1) {
                setIsOnTimer(false);
                return;
            }
            document.getElementById(`p-${curIndex + 1}`)!.style.backgroundColor = "#bebebe";
            setCurIndex(curIndex + 1);
        }
    }

    return <div className="wrapper">
        <div className="title mtb-10"
             style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
            <img src={logo} alt="Syntax Sprint" className="logo"/>

            <div className="languages" style={{display: "flex", justifyContent: "space-between"}}>
                <a className="badge" onClick={() => onLanguageClick(allWords)}>
                    <img className="badge-img"
                         src="https://img.shields.io/badge/Random-672394?style=plastic"
                         alt="Random"/>
                </a>
                <a className="badge" onClick={() => onLanguageClick(pyWords)}>
                    <img className="badge-img"
                         src="https://img.shields.io/badge/Python-3776AB?style=plastic&logo=python&logoColor=white"
                         alt="Python"/>
                </a>
                <a className="badge" onClick={() => onLanguageClick(goWords)}>
                    <img className="badge-img"
                         src="https://img.shields.io/badge/Go-00ADD8?style=plastic&logo=go&logoColor=white"
                         alt="Golang"/>
                </a>
                <a className="badge" onClick={() => onLanguageClick(jsWords)}>
                    <img className="badge-img"
                         src="https://img.shields.io/badge/JavaScript-BBBB11?style=plastic&logo=JavaScript&logoColor=white"
                         alt="JavaScript"/>
                </a>
                <a className="badge" onClick={() => onLanguageClick(javaWords)}>
                    <img className="badge-img"
                         src="https://img.shields.io/badge/Java-ED8B00?style=plastic&logo=openjdk&logoColor=white"
                         alt="Java"/>
                </a>
                <a className="badge" onClick={() => onLanguageClick(cppWords)}>
                    <img className="badge-img"
                         src="https://img.shields.io/badge/C%2B%2B-00599C?style=plastic&logo=c%2B%2B&logoColor=white"
                         alt="C++"/>
                </a>
                <a className="badge" onClick={() => onLanguageClick(csWords)}>
                    <img className="badge-img"
                         src="https://img.shields.io/badge/C%23-239120?style=plastic&logo=c-sharp&logoColor=white"
                         alt="C#"/>
                </a>
                <a className="badge" onClick={() => onLanguageClick(sqlWords)}>
                    <img className="badge-img"
                         src="https://img.shields.io/badge/SQL-005C84?style=plastic"
                         alt="SQL"/>
                </a>
            </div>
        </div>

        <div className="content" style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
            <article className="text">
                {wordsList.map((w, index) => <p className="text-element" key={`p-${index}`} id={`p-${index}`}>{w}</p>)}
            </article>
            {!isOnTimer && seconds != 60 ?
                <div className="result">
                    <p className="result-text">
                        Your result: {seconds ? Math.floor(result / seconds * 60) : result} programming WPM
                    </p>
                </div>
                : <></>}

            <p className="timer">
                {`${Math.floor(seconds / 60)}:${(seconds % 60 < 10 ? "0" : "") + (seconds % 60).toString()}`}
            </p>
            <div className="input_block" style={{display: "flex"}}>
                <input autoComplete="off" autoCapitalize="off" autoCorrect="off" spellCheck={false} value={curInput}
                       type="text" className="text-field mr-10" onInput={onChange}/>
                <button className="reset-btn" onClick={() => setReloadCounter(reloadCounter+1)}>🔄</button>
            </div>
        </div>
    </div>
}

export default TypeTester;